import { COUNTRIES, type CountryCode } from "../lib/countries";
import { useT } from "../i18n";

interface Props {
  value: CountryCode;
  onChange: (code: CountryCode) => void;
}

/** Výběr země – přepne výchozí pohled mapy na danou zemi. */
export default function CountryPicker({ value, onChange }: Props) {
  const t = useT();
  return (
    <select
      className="country-picker"
      aria-label={t("country.label")}
      value={value}
      onChange={(e) => onChange(e.target.value as CountryCode)}
    >
      {COUNTRIES.map((c) => (
        <option key={c.code} value={c.code}>
          {t(`country.${c.code}`)}
        </option>
      ))}
    </select>
  );
}
